/* 🤖 this file was generated by svg-to-ts */
export const mgcIconRightSmallRegular: {
  name: 'right-small-regular';
  data: string;
} = {
  name: 'right-small-regular',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M10.813 8.204c-.314.058-.547.235-.706.535-.112.212-.118.657-.012.861.04.077.579.648 1.199 1.27L12.419 12l-1.125 1.13c-.62.622-1.159 1.193-1.199 1.27-.106.204-.1.649.012.861.258.487.815.683 1.318.461.285-.125 3.172-3.012 3.297-3.297a1.099 1.099 0 0 0 0-.85c-.122-.277-3.013-3.173-3.282-3.288a1.02 1.02 0 0 0-.627-.083"/></svg>`
};
